import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';
import { IJoinRequests } from '../Types';

const RESOURCE = 'join-requests';

interface IGetJoinRequests extends Omit<IUri, 'resource'> {
  appKey: string;
  token: string;
}

interface IGetJoinRequestsResponse extends IHttpResponse {
  body?: IJoinRequests;
}

export default ({
  appKey,
  token,
}: IGetJoinRequests): Promise<IGetJoinRequestsResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    filters: [
      ['app_key', appKey],
      ['role', 'manager'],
      ['status', 'pending'],
    ],
    sorts: ['-created_at'],
    resource: RESOURCE,
  });

  return BaseService.Get({
    url,
    appKey,
    token,
    skipTimestamp: true,
  });
};
